import { createContext, useEffect, useState } from "react";
import { TranslationContextValue, TranslationProviderProps } from "./types";
import { translate } from "../../translation";

export const TranslationContext = createContext<TranslationContextValue>({
  intl: (selector: string) => selector,
  setIntl: () => {},
  language: undefined,
  setLanguage: () => {},
});

export function TranslationProvider({
  children,
  lang,
}: TranslationProviderProps) {
  const [intl, setIntl] = useState<(selector: string) => string>(
    () => (selector: string) => selector
  );
  const [language, setLanguage] = useState<boolean | undefined>(false);

  useEffect(() => {
    setIntl(() => (selector: string) => translate(selector, lang ?? "uk"));
    // console.log("LANGUAGE IN CONTEXT: ", lang);
    setLanguage(lang === "uk" ? true : false);
  }, [lang]);

  return (
    <TranslationContext.Provider value={{ intl, setIntl, language, setLanguage }}>
      {children}
    </TranslationContext.Provider>
  );
}
